import attributes from './attributes.js';
import Editor from './Editor';
import Save from './Save';

const { registerBlockType } = wp.blocks;

registerBlockType('image-text/block', {
    title: 'Texto com Imagem',
    description: 'Coloque Imagem e Texto lado a lado',
    icon: 'align-pull-left',
    category: 'media',
    attributes,
    supports: {
        align: true,
        color: {
            gradients: true,
        },
        spacing: {
            margin: true,
            padding: true,
            blockGap: true,
        },
    },
    edit: props => <Editor {...props} />,
    save: props => <Save {...props} />
});
